// extracted by mini-css-extract-plugin
module.exports = {"header":"insurances_header__2cY7R","insuranceItems":"insurances_insuranceItems__38Zyn","container":"insurances_container__5PQ2x","splitter":"insurances_splitter__2hqbE"};